import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IArticulo, 
  IArticuloRequest, 
  IArticuloResponse, 
  IArticuloDeleteRequest, 
  IArticuloDeleteResponse,
  ILineaArticuloRequest,
  ILineaArticuloResponse,
  IArticuloCreateRequest,
  IFechaJulianaRequest,
  IFechaJulianaResponse,
  IArticuloGetRequest,
  IArticuloGetResponse,
  IFechaJulianaToStringRequest,
  IFechaJulianaToStringResponse,
  IArticuloEditRequest,
  IArticuloEditResponse
} from '../interfaces/iArticulo';

@Injectable({
  providedIn: 'root'
})
export class ArticuloService {
  private apiUrl = `${environment.apiNewBackBaseUrl}`;

  constructor(private http: HttpClient) { }

  GetArticulos(): Observable<IArticuloResponse> {
    const request: IArticuloRequest = {
      que: 4,
      tope: "999",
      cmd: "",
      numero_articulo: "",
      numero_linea: "",
      descripcion: "",
      precio: 0,
      precio_Propio: 0,
      fecha_Cotizacion: 0
    };
    return this.http.post<IArticuloResponse>(`${this.apiUrl}Garantias/ArticulosList`, request);
  }

  getFechaJuliana(fecha: string): Observable<IFechaJulianaResponse> {
    const request: IFechaJulianaRequest = { fecha };
    return this.http.post<IFechaJulianaResponse>(`${this.apiUrl}Articulos/cmspa_FechaStrJul`, request);
  }

  CreateArticulo(articulo: IArticulo): Observable<IArticuloResponse> {
    // La fecha viene en formato YYYY-MM-DD, la convertimos a dd/mm/yyyy
    const fecha = articulo.fecha_Cotizacion;
    const [year, month, day] = fecha.toString().split('-');
    const fechaFormateada = `${day}/${month}/${year}`;

    return this.getFechaJuliana(fechaFormateada).pipe(
      switchMap(fechaJuliana => {
        const request: IArticuloCreateRequest = {
          que: 1,
          tope: "100",
          cmd: "",
          numeroArticulo: articulo.numero_articulo.toString(),
          numeroLinea: articulo.numero_linea,
          descripcion: articulo.descripcion,
          precio: articulo.precio,
          precioPropio: articulo.precio_Propio,
          fechaCotizacion: fechaJuliana.data.juliana
        };
        return this.http.post<IArticuloResponse>(`${this.apiUrl}Articulos/cmspa_articulos`, request);
      })
    );
  }

  UpdateArticulo(articulo: IArticulo): Observable<IArticuloEditResponse> {
    // La fecha viene en formato YYYY-MM-DD, la convertimos a dd/mm/yyyy
    const fecha = articulo.fecha_Cotizacion;
    const [year, month, day] = fecha.toString().split('-');
    const fechaFormateada = `${day}/${month}/${year}`;

    return this.getFechaJuliana(fechaFormateada).pipe(
      switchMap(fechaJuliana => {
        const request: IArticuloEditRequest = {
          tope: "",
          cmd: "",
          numeroArticulo: articulo.numero_articulo,
          numeroLinea: articulo.numero_linea,
          descripcion: articulo.descripcion,
          precio: articulo.precio,
          precioPropio: articulo.precio_Propio,
          fechaCotizacion: fechaJuliana.data.juliana
        };
        return this.http.post<IArticuloEditResponse>(`${this.apiUrl}Articulos/EditArticulo`, request);
      })
    );
  }

  DeleteArticulo(numero_articulo: string): Observable<IArticuloDeleteResponse> {
    const request: IArticuloDeleteRequest = {
      tope: "",
      cmd: "",
      numeroArticulo: numero_articulo,
      numeroLinea: "",
      descripcion: "",
      precio: 0,
      precioPropio: 0,
      fechaCotizacion: 0
    };
    return this.http.post<IArticuloDeleteResponse>(`${this.apiUrl}Articulos/DelArticulo`, request);
  }

  GetLineasArticulos(): Observable<ILineaArticuloResponse> {
    const request: ILineaArticuloRequest = {
      cmd: "",
      contrato: "",
      descripcion: "",
      identificacion: "",
      monto: "",
      numeroLinea: "",
      otraDescripcion: "",
      score: 0,
      telefono: "",
      tipo: "",
      tope: "999"
    };
    return this.http.post<ILineaArticuloResponse>(`${this.apiUrl}Articulos/cmspa_lineas`, request);
  }

  GetArticulo(numeroArticulo: string): Observable<IArticuloGetResponse> {
    const request: IArticuloGetRequest = {
      tope: "",
      cmd: "",
      numeroArticulo,
      numeroLinea: "",
      descripcion: "",
      precio: 0,
      precioPropio: 0,
      fechaCotizacion: 0
    };
    return this.http.post<IArticuloGetResponse>(`${this.apiUrl}Articulos/GetArticulo`, request);
  }

  getFechaString(fechaJuliana: number): Observable<IFechaJulianaToStringResponse> {
    const request: IFechaJulianaToStringRequest = { 
      fechaEntera: fechaJuliana.toString() 
    };
    return this.http.post<IFechaJulianaToStringResponse>(`${this.apiUrl}Articulos/cmspa_FechaJulStr`, request);
  }
} 